<template>
  <div v-if="emptyContainer" :style="cssVars" class="flex relative" :class="getSizesClasses()">
    <div class="separator rounded-full">
      &nbsp;
    </div>
    <div class="bloc"></div>
    <div class="hidden"></div>
  </div>

  <div
    v-else
    :style="cssVars"
    class="flex relative"
    :class="[answer.isEOL ? 'bloc--is-eol ' : ''] + getSizesClasses()"
    @click="handleSelectAnswer"
    ref="bloc"
  >
    <div v-if="gridMode !== 'free' && isFirst" class="separator rounded-full">
      &nbsp;
    </div>

    <div
      class="bloc flex flex-col text-left leading-none select-none cursor-move relative"
      :class="{
        'bloc--is-selected': isSelected,
        'bloc-mode-free': gridMode === 'free',
        'bloc-with-shadow': shadowIsActive,
      }"
      :id="order"
      :style="
        (gridMode === 'free' && answerPosition !== undefined
          ? 'left:' + answerPosition.left + 'px;' + 'top:' + answerPosition.top + 'px;'
          : '') +
          'background-color:' +
          (!answer.isEOL ? colors.bg : '#ffffff')
      "
    >
      <div
        v-if="gridMode === 'free'"
        class="absolute w-6 h-6 -ml-4 -mt-4 pt-2 pl-2 flex rounded-full invisible"
        :class="[
          isSelected ? 'bg-blue' : 'bg-gray-500',
          isGroupTopLeft && (!isSelected || isGroupSelected) ? 'bloc-group-icon--is-visible' : '',
        ]"
        style="z-index: -1;"
        @mousedown="handleSelectGrouppedAnswers()"
        @click="handleDeSelectGrouppedAnswers($event)"
      >
        <div class="w-2 h-2 border-t-2 border-l-2 border-solid border-white"></div>
      </div>

      <div
        class="label flex items-center relative"
        :class="{
          '': idsDisplay['label'],
          'border-none': !idsDisplay['label'],
          'rounded-full border-solid': idsDisplay['number'] || idsDisplay['label'],
        }"
        :style="
          idsDisplay['label']
            ? 'color:' + colors.title + ';background-color:' + colors.contrast + ';border-color:' + colors.border
            : ''
        "
      >
        <div v-if="answer.isSelected" class="absolute w-full -mt-2 flex justify-center invisible bloc-selected-count">
          <div class="bg-blue rounded-full text-white px-1">+{{ getSelectedCount }}</div>
        </div>
        <div
          v-if="idsDisplay['number'] && !answer.isEOL"
          class="absolute number text-center rounded-full border-solid border-gray-300"
          :style="'color:' + colors.font + ';background-color:' + colors.bg + ';border-color:' + colors.border"
        >
          {{
              answer.number > 999
              ? "999+"
              : parseInt(answer.number) + (answer.merged_answers_count !== undefined ? "+" : "")
          }}
        </div>
        <div
          v-if="idsDisplay['number'] || idsDisplay['label']"
          class="label-text flex-grow text-center overflow-hidden"
        >
          <div v-if="idsDisplay['label'] && !answer.isEOL" class="px-4">
            <p class="px-3 truncate">{{ labelName }}</p>
          </div>
          <div v-if="answer.isEOL">Fin de groupe</div>
          <div v-else>&nbsp;</div>
        </div>
        <div class="star absolute right-0">
          <img v-if="answer.isTop" class="cursor-pointer" src="../assets/icons/topAnswer.svg" alt="Top" />
          <img v-if="answer.isFirstTop" class="cursor-pointer" src="../assets/icons/firstTopAnswer.svg" alt="Top" />
        </div>
      </div>

      <div class="flex-grow h-full px-2 py-1 overflow-hidden" ref="container">
        <div v-if="!answer.isEOL" class="answer-text" :style="'color:' + (!answer.isEOL ? colors.font : 'inherit')">
          {{ answer.text }}
        </div>
        <div v-else class="flex h-full items-end">
          <button
            class="w-1/2 h-12 mr-1 text-xs text-blue border-2 border-blue rounded-lg hover:bg-blue hover:text-white focus:outline-none"
            @click="selectGrouppedAnswers(answer.groupIndex)"
          >
            Sélection du groupe
          </button>
          <button
            class="w-1/2 h-12 ml-1 text-xs text-blue border-2 border-blue rounded-lg hover:bg-blue hover:text-white focus:outline-none"
            @click="removeInlineGroup(answer.groupIndex)"
          >
            Supprimer
          </button>
        </div>
      </div>

      <div class="w-full p-1">
        <div v-if="!answer.isEOL" class="relative">
          <div
            class="percent-bar absolute z-0 rounded-full"
            :class="[colors.bg === '#FFFFFF' ? 'bg-gray-300' : 'bg-white']"
            :style="'width:' + getLikesPercent() + '%;'"
          />
        </div>
        <div class="percent-number flex justify-between px-1 relative z-10">
          <div v-if="likesDisplay !== 'number' && !answer.isEOL">{{ getLikesPercent() }}%</div>
          <div v-if="!answer.isEOL">
            {{ answer.merged_answers_count !== undefined ? answer.merged_likes_count : answer.likes_count }}
          </div>
        </div>
      </div>
    </div>

    <div v-if="gridMode !== 'free'" class="separator rounded-full">&nbsp;</div>

    <div v-if="answer.isEOL" class="collidable" :style="'width:' + getEOLWidth() + 'px;'"></div>
    <!-- avoid over blue separator for EOL element -->
    <div class="hidden" v-if="answer.isEOL"></div>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapState } from "vuex"

export default {
  props: {
    id: Number,
    order: Number,
    isFirst: Boolean,
    containerIndex: Number,
    answer: Object,
    answerPosition: Object,
    colors: Object,
    labelName: String,
    isSelected: Boolean,
    isGroupSelected: Boolean,
    likesMax: Number,
    charsMax: Number,
    itemsPerLine: Number,
    realItemsPerLine: Number,
    itemSizeWithMargins: Object,
    gridMode: String,
    likesDisplay: String,
    idsDisplay: Object,
    connected: Number,
    attendees: Number,
    filter: String,
    emptyContainer: Boolean,
    lowestItem: Object,
  },
  data() {
    return {
      mouseDownSelect: false,
      top: 0,
    }
  },
  computed: {
    ...mapGetters("answers", ["getSelectedCount", "groupLength"]),
    ...mapState({
      shadowIsActive: (state) => state.labels.options.shadowIsActive,
      groups: (state) => state.answers.groups,
    }),
    isGroupTopLeft() {
      return this.answer.isGroupTopLeft
    },
    cssVars() {
      return {
        "--item-size":
          this.itemsPerLine === 5
            ? process.env.VUE_APP_BIG_SIZE + "px"
            : this.itemsPerLine === 7
            ? process.env.VUE_APP_MEDIUM_SIZE + "px"
            : process.env.VUE_APP_SMALL_SIZE + "px",
        "--item-height":
          this.itemsPerLine === 5
            ? process.env.VUE_APP_BIG_SIZE / (this.charsMax === 30 ? 1.5 : 1) + "px"
            : this.itemsPerLine === 7
            ? process.env.VUE_APP_MEDIUM_SIZE / (this.charsMax === 30 ? 1.5 : 1) + "px"
            : process.env.VUE_APP_SMALL_SIZE / (this.charsMax === 30 ? 1.5 : 1) + "px",
      }
    },
  },
  watch: {
    isSelected() {
      if (this.isGroupped()) {
        if (this.isSelected) {
          this.$refs["bloc"].classList.remove("bloc--is-superimposed")
        } else {
          this.$refs["bloc"].classList.add("bloc--is-superimposed")
        }
      }
    },
  },
  methods: {
    ...mapMutations("answers", ["removeAnswerTopLeft", "selectGrouppedAnswers", "removeInlineGroup"]),
    handleSelectGrouppedAnswers() {
      // free mode group
      // handle onmousedown group select
      if (!this.isSelected) {
        this.mouseDownSelect = true
        this.$emit("selectGrouppedAnswers", this.getGroupIndex())
      } else {
        this.mouseDownSelect = false
      }
    },
    handleDeSelectGrouppedAnswers(event) {
      // free mode group
      // handle onclick group deselect
      event.stopPropagation()
      if (!this.mouseDownSelect) {
        let groupIndex = null
        this.groups.forEach((group, index) => {
          if (group.includes(this.id)) {
            groupIndex = index
          }
        })
        this.$emit("selectGrouppedAnswers", this.getGroupIndex())
      }
    },
    getGroupIndex() {
      let groupIndex = null
      this.groups.forEach((group, index) => {
        if (group.includes(this.id)) {
          groupIndex = index
        }
      })
      return groupIndex
    },
    isGroupped() {
      return this.getGroupIndex() !== null
    },
    handleSelectAnswer() {
      // avoid individual selection when element is part of a group in 'free' mode
      if (this.isGroupped() && this.gridMode === "free") {
        return
      }

      // avoid selection on EOL
      if (this.answer.isEOL) {
        return
      }

      this.$emit("selectAnswer", this.id)
    },
    getEOLWidth() {
      let itemsPerLine = Math.min(this.realItemsPerLine, this.itemsPerLine)
      console.log("group length ", this.groupLength(this.answer.groupIndex))
      if (!((this.groupLength(this.answer.groupIndex) + 1) % itemsPerLine)) {
        return 0
      } else {
        return (
          (itemsPerLine - ((this.groupLength(this.answer.groupIndex) + 1) % itemsPerLine)) *
          this.itemSizeWithMargins.width
        )
      }
    },
    getLikesPercent() {
      const likes_count =
        this.answer.merged_answers_count !== undefined ? this.answer.merged_likes_count : this.answer.likes_count
      switch (this.likesDisplay) {
        case "number":
          return Math.min(Math.round((likes_count / this.likesMax) * 100), 100)
        case "connected":
          return Math.min(Math.round((likes_count / this.connected) * 100), 100)
        case "attendees":
          return Math.min(Math.round((likes_count / this.attendees) * 100), 100)
      }
    },
    getSizesClasses() {
      if (this.emptyContainer !== true) {
        if (this.answer.chars_count < 45) {
          return "text-45"
        } else if (this.answer.chars_count < 140) {
          return "text-140"
        } else {
          return "text-240"
        }
      }
    },
  },
  beforeUpdate() {
    if (process.env.NODE_ENV !== "production") {
      const time = new Date()
      const formattedTime = ` @ ${pad(time.getHours(), 2)}:${pad(time.getMinutes(), 2)}:${pad(
        time.getSeconds(),
        2
      )}.${pad(time.getMilliseconds(), 3)}`
      console.log(this.id, " updated ! " + formattedTime)
    }
  },
}

function repeat(str, times) {
  return new Array(times + 1).join(str)
}
function pad(num, maxLength) {
  return repeat("0", maxLength - num.toString().length) + num
}
</script>
<style scoped>
.bloc-with-shadow {
  box-shadow: 0 0.1rem 0.1rem rgba(0, 0, 0, 0.1), 0 0 0.5rem 0.1rem rgba(0, 0, 0, 0.1);
}
.bloc-mode-grid {
  @apply flex flex-col;
}
.bloc-mode-free {
  @apply absolute z-0;
}
.bloc--is-selected {
  box-shadow: 0 0 0 5px rgb(3, 194, 235);
}
.bloc--is-superimposed > div.bloc-mode-free {
  box-shadow: 0 0 0 5px rgb(160, 174, 192);
}
.bloc-group-icon--is-visible,
.bloc-selected-count--is-visible {
  @apply visible;
}
.bloc {
  hyphens: auto;
  margin: calc(var(--item-size) / 15) calc(var(--item-size) / 20);
  border-radius: calc(var(--item-size) / 20);
  width: var(--item-size);
  height: var(--item-height);
  font-size: calc(var(--item-size) / 12);
}
.bloc .label {
  border-width: calc(var(--item-size) / 100);
}
.bloc .number {
  margin-left: calc(-1 * var(--item-size) / 100);
  border-width: calc(var(--item-size) / 100);
}
.separator {
  margin: calc(var(--item-size) / 10) 0;
  width: calc(var(--item-size) / 20);
}
.text-240 > .bloc .answer-text {
  font-size: calc(var(--item-size) / 15);
  line-height: calc(var(--item-size) / 13);
}
.text-140 > .bloc .answer-text {
  font-size: calc(var(--item-size) / 12);
  line-height: calc(var(--item-size) / 10);
}
.text-45 > .bloc .answer-text {
  font-size: calc(var(--item-size) / 7);
  line-height: calc(var(--item-size) / 5.5);
}
.bloc .number {
  min-width: calc(var(--item-size) / 10);
  height: calc(var(--item-size) / 10);
}
.bloc .label-text {
  min-height: calc(var(--item-size) / 12);
}
.bloc .star {
  margin-right: calc(-1 * var(--item-size) / 25);
}
.bloc .star img {
  width: calc(var(--item-size) / 8);
  height: calc(var(--item-size) / 8);
}
.bloc .percent-bar {
  height: calc(var(--item-size) / 12);
}
.bloc .percent-number {
  line-height: calc(var(--item-size) / 11);
}
/* big / question maxChars = 120 */
/*.big-120-120 > .bloc .answer-text {
  font-size: 30px;
  line-height: 1.45;
}
.big-120-60 > .bloc .answer-text {
  font-size: 40px;
  line-height: 1.25;
}
.big-120-30 > .bloc .answer-text {
  font-size: 50px;
  line-height: 1.25;
}
.big-120 > .bloc {
  width: 320px;
  height: 320px;
  font-size: 30px;
}
.big-120 > .bloc .number {
  min-width: 38px;
  height: 38px;
}
.big-120 > .bloc .label-text {
  min-height: 30px;
}
.big-120 > .bloc .star img {
  width: 44px;
  height: 44px;
}
.big-120 > .bloc .percent-bar {
  height: 30px;
}
/* big / question maxChars = 30 */
/*.big-30 > .bloc .answer-text {
  text-align: center;
  font-size: 30px;
  line-height: 1.35;
}
.big-30 > .bloc {
  width: 320px;
  height: 200px;
  font-size: 30px;
}
.big-30 > .bloc .number {
  min-width: 38px;
  height: 38px;
}
.big-30 > .bloc .label-text {
  min-height: 30px;
}
.big-30 > .bloc .star img {
  width: 44px;
  height: 44px;
}
.big-30 > .bloc .percent-bar {
  height: 30px;
}

/* medium */
/*.medium > .bloc {
  margin: 18px 12px;
  border-radius: 0.65rem;
}
.medium > .bloc .label {
  border-width: 3px 3px 3px 3px;
}
.medium > .bloc .number {
  margin-left: -3px;
  border-width: 3px;
  padding: 1px 2px 0 3px;
}
.medium > .separator {
  margin: 18px 0;
  width: 10px;
}
/* medium / question maxChars = 240 */
/*.medium-240-240 > .bloc .answer-text {
  font-size: 15px;
  line-height: 1.45;
}
.medium-240-140 > .bloc .answer-text {
  font-size: 20px;
  line-height: 1.25;
}
.medium-240-45 > .bloc .answer-text {
  font-size: 25px;
  line-height: 1.25;
}
.medium-240 > .bloc {
  width: 226px;
  height: 226px;
  font-size: 15px;
}
.medium-240 > .bloc .number {
  min-width: 22px;
  height: 22px;
}
.medium-240 > .bloc .label-text {
  min-height: 15px;
}
.medium-240 > .bloc .star img {
  width: 31px;
  height: 31px;
}
.medium-240 > .bloc .percent-bar {
  height: 15px;
}
/* medium / question maxChars = 120 */
/*.medium-120-120 > .bloc .answer-text {
  font-size: 20px;
  line-height: 1.45;
}
.medium-120-60 > .bloc .answer-text {
  font-size: 25px;
  line-height: 1.25;
}
.medium-120-30 > .bloc .answer-text {
  font-size: 30px;
  line-height: 1.25;
}
.medium-120 > .bloc {
  width: 226px;
  height: 226px;
  font-size: 20px;
}
.medium-120 > .bloc .number {
  min-width: 25px;
  height: 25px;
}
.medium-120 > .bloc .label-text {
  min-height: 20px;
}
.medium-120 > .bloc .star img {
  width: 33px;
  height: 33px;
}
.medium-120 > .bloc .percent-bar {
  height: 20px;
}
/* medium / question maxChars = 30 */
/*.medium-30 > .bloc .answer-text {
  text-align: center;
  font-size: 20px;
  line-height: 1.35;
}
.medium-30 > .bloc {
  width: 226px;
  height: 133px;
  font-size: 18px;
}
.medium-30 > .bloc .number {
  min-width: 25px;
  height: 25px;
}
.medium-30 > .bloc .label-text {
  min-height: 18px;
}
.medium-120 > .bloc .star img {
  width: 33px;
  height: 33px;
}
.medium-30 > .bloc .percent-bar {
  height: 18px;
}

/* small */
/*.small > .bloc {
  margin: 18px 12px;
  border-radius: 0.65rem;
}
.small > .bloc .label {
  border-width: 2px 2px 2px 2px;
}
.small > .bloc .number {
  margin-left: -2px;
  border-width: 2px;
  padding: 0 1px;
}
.small > .separator {
  margin: 18px 0;
  width: 10px;
}
/* small / question maxChars = 240 */
/*.small-240-240 > .bloc .answer-text {
  font-size: 11px;
  line-height: 1.45;
}
.small-240-140 > .bloc .answer-text {
  font-size: 18px;
  line-height: 1.25;
}
.small-240-45 > .bloc .answer-text {
  font-size: 25px;
  line-height: 1.25;
}
.small-240 > .bloc {
  width: 170px;
  height: 170px;
  font-size: 11px;
}
.small-240 > .bloc .number {
  min-width: 15px;
  height: 15px;
}
.small-240 > .bloc .label-text {
  min-height: 11px;
}
.small-240 > .bloc .star img {
  width: 25px;
  height: 25px;
}
.small-240 > .bloc .percent-bar {
  height: 11px;
}
/* small / question maxChars = 120 */
/*.small-120-120 > .bloc .answer-text {
  font-size: 15px;
  line-height: 1.45;
}
.small-120-60 > .bloc .answer-text {
  font-size: 22px;
  line-height: 1.25;
}
.small-120-30 > .bloc .answer-text {
  font-size: 28px;
  line-height: 1.25;
}
.small-120 > .bloc {
  width: 170px;
  height: 170px;
  font-size: 16px;
}
.small-120 > .bloc .number {
  min-width: 20px;
  height: 20px;
}
.small-120 > .bloc .label-text {
  min-height: 16px;
}
.small-120 > .bloc .star img {
  width: 29px;
  height: 29px;
}
.small-120 > .bloc .percent-bar {
  height: 16px;
}
/* small / question maxChars = 30 */
/*.small-30 > .bloc .answer-text {
  text-align: center;
  font-size: 15px;
  line-height: 1.35;
}
.small-30 > .bloc {
  width: 170px;
  height: 105px;
  font-size: 16px;
}
.small-30 > .bloc .number {
  min-width: 20px;
  min-height: 20px;
}
.small-30 > .bloc .label-text {
  min-height: 16px;
}
.small-30 > .bloc .star img {
  width: 29px;
  height: 29px;
}
.small-30 > .bloc .percent-bar {
  height: 16px;
}*/

.separator--is-active {
  @apply bg-blue;
}
</style>
